/* eslint-disable @typescript-eslint/no-unsafe-function-type */
import type { FC } from 'react';
import React, { useContext } from 'react';

import { EditorContext, ModalServiceContext, UploadContext, useDevService } from './../../ricos-context';
import { handleImageUpload } from './../handle-image-upload';

import { IMAGE_EDITOR_MODAL_ID } from '../consts';
import { setupImageEditor } from '../imageStudio/image-editor-logic';
import type { ImageEditorWixSettings, ImagePluginEditorConfig } from '../types';

interface Props {
  nodeId: string;
  src: string;
  config: ImagePluginEditorConfig;
}

const ImageEditorModal: FC<Props> = ({ nodeId, config, src }) => {
  const modalService = useContext(ModalServiceContext) || {};
  const { uploadService } = useContext(UploadContext) || {};
  const { getPublicCommands } = useContext(EditorContext);
  const devService = useDevService();

  const id = 'imageEditor';

  React.useEffect(() => {
    const onClose = () => {
      modalService.closeModal(IMAGE_EDITOR_MODAL_ID);
    };

    const onSave = (file: File) => {
      handleImageUpload({
        services: { uploadService: uploadService!, devService },
        config,
        publicCommands: getPublicCommands(),
        nodeId,
        files: [file],
      });
      onClose();
    };

    config.onImageEditorOpen && config.onImageEditorOpen();

    setupImageEditor(
      config.imageEditorWixSettings ?? ({} as ImageEditorWixSettings),
      id,
      src,
      onSave,
      onClose
    );
  }, []);

  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  // eslint-disable-next-line react/no-unknown-property
  return <div id={id} nofocus="true" />;
};

export default ImageEditorModal;
